import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  FormControlLabel,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  Chip,
  Avatar,
  Snackbar,
  Alert,
  LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import { useNavigate } from "react-router-dom";

const AddAdPage = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [title, setTitle] = useState("");
  const [categories, setCategories] = useState([]);
  const [canAddAd, setCanAddAd] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [isLoadingCanAdd, setIsLoadingCanAdd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    title: false,
    photos: false,
    price: false,
    contact: false,
    ad_sub_category_type_id: false,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [formData, setFormData] = useState({
    description: "",
    is_ad: 1,
    price: "",
    is_show_price: 1,
    address: "",
    video_url: "",
    site_url: "",
    phone: "",
    email: "",
    ad_sub_category_type_id: "",
  });

  const handlePhotoUpload = (e) => {
    const newFiles = Array.from(e.target.files);
    setPhotos((prevPhotos) => [...prevPhotos, ...newFiles]);
    e.target.value = "";
  };

  const removePhoto = (index) => {
    setPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep((prev) => prev + 1);
    }
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const validateStep = (step) => {
    switch (step) {
      case 1:
        return title.trim().length > 0;
      case 2:
        return selectedCategory !== null;
      case 3:
        return selectedSubCategory !== null;
      default:
        return true;
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setSelectedSubCategory(null); // Reset subcategory when category changes
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    let check = 1;
    if (type === "checkbox") {
      if (checked) check = 1;
      else check = 0;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? check : value,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let valid = true;
    const newErrors = { ...errors };

    if (!title.trim()) {
      newErrors.title = true;
      valid = false;
    } else {
      newErrors.title = false;
    }

    if (photos.length === 0) {
      newErrors.photos = true;
      valid = false;
      setOpenSnackbar(true);
    } else {
      newErrors.photos = false;
    }
    if (formData.price === "") {
      newErrors.price = true;
      valid = false;
      setOpenSnackbar(true);
    } else {
      newErrors.price = false;
    }
    if (formData.ad_sub_category_type_id === "") {
      newErrors.ad_sub_category_type_id = true;
      valid = false;
      setOpenSnackbar(true);
    } else {
      newErrors.ad_sub_category_type_id = false;
    }
    if (formData.email === "" && formData.phone === "") {
      newErrors.contact = true;
      valid = false;
      setOpenSnackbar(true);
    } else {
      newErrors.contact = false;
    }
    setErrors(newErrors);
    if (!valid) {
      setIsLoading(false);
      return;
    }

    const data = new FormData();
    photos.forEach((photo) => {
      data.append("photos[]", photo);
    });
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "photos") {
        if (Array.isArray(value)) {
          value.forEach((item) => data.append(`${key}[]`, item));
        } else if (value instanceof Object && !(value instanceof File)) {
          data.append(key, JSON.stringify(value));
        } else {
          data.append(key, value);
        }
      }
    });
    data.append("title", title);
    const { response, message } = await Helper.Post({
      url: api_Routes.UserAds.createAd,
      hasToken: true,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response) navigate("/home");
    setIsLoading(false);
  };
  useEffect(() => {
    const get_Categories = async () => {
      setIsLoadingCategories(true);
      const { response, message } = await Helper.Get({
        url: api_Routes.UserAds.getCategories,
        hasToken: true,
      });
      if (response?.data) {
        setCategories(response?.data);
      }
      setIsLoadingCategories(false);
    };
    const get_Can_add_ad = async () => {
      setIsLoadingCanAdd(true);
      const { response, message } = await Helper.Get({
        url: api_Routes.UserAds.canAdd,
        hasToken: true,
      });
      if (response?.data) {
        setCanAddAd(response?.data);
      }
      setIsLoadingCanAdd(false);
    };
    get_Categories();
    get_Can_add_ad();
  }, []);

  console.log(canAddAd)
  if (isLoadingCategories || isLoadingCanAdd) return <LinearProgress />;
  return (
      <>
      {
        canAddAd ?
            <Box sx={{ maxWidth: 800, margin: "auto", p: 3 }}>
              <Stepper activeStep={currentStep - 1} alternativeLabel sx={{ mb: 4 }}>
                <Step>
                  <StepLabel>Title</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Category</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Subcategory</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Details</StepLabel>
                </Step>
              </Stepper>

              {/* Step 1: Title */}
              {currentStep === 1 && (
                  <Box>
                    <Typography variant="h5" gutterBottom>
                      Add your ad title
                    </Typography>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Ad Title"
                        value={title}
                        error={errors.title}
                        helperText={errors.title ? "Title is required" : ""}
                        onChange={(e) => {
                          setTitle(e.target.value);
                          if (errors.title)
                            setErrors((prev) => ({ ...prev, title: false }));
                        }}
                        sx={{ mb: 3 }}
                    />
                  </Box>
              )}

              {/* Step 2: Category Selection */}
              {currentStep === 2 && (
                  <Box>
                    <Typography variant="h5" gutterBottom>
                      Select a Category
                    </Typography>
                    <List>
                      {categories.map((category) => (
                          <ListItem key={category.id} disablePadding>
                            <ListItemButton
                                selected={selectedCategory?.id === category.id}
                                onClick={() => handleCategorySelect(category)}
                            >
                              <ListItemText primary={category.name} />
                            </ListItemButton>
                          </ListItem>
                      ))}
                    </List>
                  </Box>
              )}

              {/* Step 3: Subcategory Selection */}
              {currentStep === 3 && (
                  <Box>
                    <Typography variant="h5" gutterBottom>
                      Select a Subcategory for {selectedCategory?.name}
                    </Typography>
                    <List>
                      {selectedCategory?.subcategories.map((sub) => (
                          <ListItem key={sub.id} disablePadding>
                            <ListItemButton
                                selected={selectedSubCategory?.id === sub.id}
                                onClick={() => setSelectedSubCategory(sub)}
                            >
                              <ListItemText primary={sub.name} />
                            </ListItemButton>
                          </ListItem>
                      ))}
                    </List>
                  </Box>
              )}

              {/* Step 4: Details Form */}
              {currentStep === 4 && (
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                      <IconButton onClick={() => setCurrentStep(1)} sx={{ mr: 2 }}>
                        <ArrowBackIcon />
                      </IconButton>
                      <TextField
                          fullWidth
                          variant="outlined"
                          label="* Ad Title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                      />
                    </Box>
                    <Box sx={{ mb: 3 }}>
                      {errors.photos && (
                          <Typography
                              color="error"
                              variant="caption"
                              sx={{ mt: 1, display: "block" }}
                          >
                            Please add at least one photo
                          </Typography>
                      )}
                      <Input
                          type="file"
                          inputProps={{
                            multiple: true,
                            accept: "image/*", // Only accept image files
                          }}
                          onChange={handlePhotoUpload}
                          id="photo-upload"
                          style={{ display: "none" }}
                      />
                      <label htmlFor="photo-upload">
                        <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            sx={{ mb: 2 }}
                        >
                          Add More Photos
                        </Button>
                      </label>

                      {/* Photo Previews with Removal Option */}
                      <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            minHeight: 100,
                            border: photos.length ? "1px dashed #ddd" : "none",
                            p: 2,
                            borderRadius: 1,
                          }}
                      >
                        {photos.length === 0 ? (
                            <Typography variant="body2" color="textSecondary">
                              No photos selected
                            </Typography>
                        ) : (
                            photos.map((photo, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                      position: "relative",
                                      width: 100,
                                      height: 100,
                                    }}
                                >
                                  <IconButton
                                      size="small"
                                      onClick={() => removePhoto(index)}
                                      sx={{
                                        position: "absolute",
                                        right: -10,
                                        top: -10,
                                        backgroundColor: "error.main",
                                        color: "white",
                                        "&:hover": {
                                          backgroundColor: "error.dark",
                                        },
                                        zIndex: 1,
                                      }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                  <img
                                      src={URL.createObjectURL(photo)}
                                      alt={`Preview ${index + 1}`}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: 4,
                                      }}
                                  />
                                </Box>
                            ))
                        )}
                      </Box>
                      <Typography variant="caption" color="textSecondary">
                        {photos.length} photo(s) selected
                      </Typography>
                    </Box>
                    <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={formData.description}
                        onChange={handleFormChange}
                        multiline
                        rows={4}
                        sx={{ mb: 3 }}
                    />

                    <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
                      <TextField
                          fullWidth
                          label="* Price"
                          name="price"
                          type="number"
                          value={formData.price}
                          onChange={handleFormChange}
                      />
                      <FormControlLabel
                          control={
                            <Checkbox
                                name="is_show_price"
                                checked={formData.is_show_price}
                                onChange={handleFormChange}
                            />
                          }
                          label="Show Price"
                      />
                    </Box>

                    <TextField
                        fullWidth
                        label="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleFormChange}
                        sx={{ mb: 3 }}
                    />

                    <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
                      <TextField
                          fullWidth
                          label="Video URL"
                          name="video_url"
                          value={formData.video_url}
                          onChange={handleFormChange}
                      />
                      <TextField
                          fullWidth
                          label="Website URL"
                          name="site_url"
                          value={formData.site_url}
                          onChange={handleFormChange}
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
                      <TextField
                          fullWidth
                          label="* Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleFormChange}
                      />
                      <TextField
                          fullWidth
                          label="* Email"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleFormChange}
                      />
                    </Box>
                    {selectedSubCategory?.subcategorytypes?.length > 0 && (
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <InputLabel>* Subcategory Type</InputLabel>
                          <Select
                              value={formData.ad_sub_category_type_id}
                              label="* Subcategory Type"
                              onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    ad_sub_category_type_id: e.target.value,
                                  }))
                              }
                          >
                            {selectedSubCategory.subcategorytypes.map((type, index) => (
                                <MenuItem key={index} value={type.id}>
                                  {type.name}
                                </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                    )}
                    <FormControlLabel
                        control={
                          <Checkbox
                              name="is_ad"
                              checked={formData.is_ad}
                              onChange={handleFormChange}
                          />
                        }
                        label="This is an advertisement"
                        sx={{ mb: 3 }}
                    />
                  </Box>
              )}
              <Snackbar
                  open={openSnackbar}
                  autoHideDuration={6000}
                  onClose={handleCloseSnackbar}
                  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity="error"
                    sx={{ width: "100%" }}
                >
                  * The Following is Required: <br />
                  {errors.photos && (
                      <b>
                        - At Least One Photo is Required
                        <br />
                      </b>
                  )}
                  {errors.price && (
                      <b>
                        - Price
                        <br />
                      </b>
                  )}
                  {errors.title && (
                      <b>
                        - Title
                        <br />
                      </b>
                  )}
                  {errors.contact && (
                      <b>
                        - One of the Email and Phone is required
                        <br />
                      </b>
                  )}
                  {errors.ad_sub_category_type_id && (
                      <b>
                        - Choose a sub category type please
                        <br />
                      </b>
                  )}
                </Alert>
              </Snackbar>
              {/* Navigation Controls */}
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
                <Button
                    variant="outlined"
                    disabled={currentStep === 1}
                    onClick={handleBack}
                >
                  Back
                </Button>

                {currentStep < 4 ? (
                    <Button
                        variant="contained"
                        onClick={handleNext}
                        disabled={!validateStep(currentStep)}
                    >
                      Next
                    </Button>
                ) : (
                    <Button variant="contained" color="success" onClick={handleSubmit}>
                      {isLoading ? "Submitting" : "Submit Ad"}
                    </Button>
                )}
              </Box>
            </Box> :
            <Box sx={{ marginTop: "20px" }}>
              <Typography
                  sx={{
                    fontSize: "40px",
                    lineHeight: "45px",
                    fontWeight: "700",
                    color: "#474747",
                    textAlign: "center",
                  }}
              >
                Sorry you rich to limit of posting ad this month
              </Typography>
              <Typography
                  sx={{
                    fontSize: "18px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#474747",
                    textAlign: "center",
                    marginTop: "30px",
                  }}
              >
                Please contact with admin or buy service of posting add by clicking here
                <Box sx={{ marginTop: 5 ,justifySelf:"center"}}>
                  <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#3F78E0",
                        color: "#F1F5FD",
                        borderRadius: "12px",
                        "&:hover": { backgroundColor: "#355dab" },
                        border: "2px solid #3F78E0",
                        display: "flex",
                        gap: "10px",
                        padding: "10px 12px",
                        boxShadow: "0px 4px 4px #00000040",
                      }}
                      onClick={() => navigate("/OurServices")}
                  >
                    <Typography
                        sx={{
                          textTransform: "capitalize",
                          fontWeight: "500",
                          fontSize: "16px",
                          color: "#F1F5FD",
                          whiteSpace: "nowrap",
                        }}
                    >
                      Buy More Ads
                    </Typography>
                    <svg
                        className="sign-up-arrow"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M11.2441 2.8457H14.0653C14.4394 2.8457 14.7982 2.99432 15.0627 3.25885C15.3273 3.52339 15.4759 3.88218 15.4759 4.25629V14.1304C15.4759 14.5045 15.3273 14.8633 15.0627 15.1278C14.7982 15.3924 14.4394 15.541 14.0653 15.541H11.2441"
                          stroke="white"
                          strokeWidth="1.41059"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                      />
                      <path
                          d="M7.7168 12.7199L11.2433 9.19346L7.7168 5.66699"
                          stroke="white"
                          strokeWidth="1.41059"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                      />
                      <path
                          d="M11.2428 9.19336H2.7793"
                          stroke="white"
                          strokeWidth="1.41059"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                      />
                    </svg>
                  </Button>
                </Box>
              </Typography>
            </Box>
      }
      </>

  );
};

export default AddAdPage;
